import React, { useCallback, useEffect } from "react";
import icon from "../../../images/Icons/product-icon.png";
import { Link, useParams } from "react-router-dom";
import config from "../../../config";
import axios from "axios";
import booked from "../../../images/Icons/booked.png";
import { useState } from "react";
import NumberFormatter from "../../../Component/NumberFormatter";
import useLogout from "../../Auth/useLogout";
import NoData from "../../../Component/NoData";
import Dataloader from "../../../Component/Dataloader";

export default function OrderDetail() {
  const params = useParams();
  const logout = useLogout();
  const [data, setData] = useState({
    productData: {
      unique_id: "",
      order_id: "",
      category: "",
      product: "",
      brand: "",
      order_date: "",
      purpose: "",
      message: "",
    },
    billing: [],
    consignee: [],
    variation: [],
    status: "",
    orderData: {
      base_price: "",
      freight: "",
      total_quantity: "",
      total_ex_price: "",
      total_freight: "",
      total_payable_amount: "",
      order_amount: "",
      paid_amount: "",
      due_amount: "",
    },
    quality: {
      certificate: "",
      images: [],
      visibility: "",
    },
    driver: [],
    invoice_list: [],
    credit_days: 0,
    packaging_charge: null,
    selected_quality: null,
    load_within: "",
    total_invoice_amount: 0,
  });
  const [exist, setExist] = useState(true);
  const [loading, setLoading] = useState(false);

  // Get status configuration based on order status
  const getStatusConfig = (status) => {
    const statusLower = status.toLowerCase();
    switch (statusLower) {
      case 'pending':
        return {
          icon: 'bi-clock-history',
          color: '#ff9800',
          bgColor: '#fff3e0',
          title: 'Order Pending',
          message: 'Your order is pending confirmation. We will notify you once it\'s reviewed.',
        };
      case 'confirm':
        return {
          icon: 'bi-check-circle',
          color: '#4caf50',
          bgColor: '#e8f5e9',
          title: 'Order Confirmed',
          message: 'Great! Your order has been confirmed and is being processed.',
        };
      case 'vehicle booked':
        return {
          icon: 'bi-truck',
          color: '#2196f3',
          bgColor: '#e3f2fd',
          title: 'Vehicle Booked',
          message: 'Transport vehicle has been booked for your order.',
        };
      case 'vehicle waiting to load':
        return {
          icon: 'bi-hourglass-split',
          color: '#3f51b5',
          bgColor: '#e8eaf6',
          title: 'Vehicle Waiting',
          message: 'Vehicle is at the location and waiting to load your order.',
        };
      case 'loading':
        return {
          icon: 'bi-box-seam',
          color: '#9c27b0',
          bgColor: '#f3e5f5',
          title: 'Loading in Progress',
          message: 'Your order is currently being loaded onto the vehicle.',
        };
      case 'bills generated':
        return {
          icon: 'bi-receipt',
          color: '#009688',
          bgColor: '#e0f2f1',
          title: 'Bills Generated',
          message: 'Invoice and shipping documents have been generated for your order.',
        };
      case 'dispatched':
        return {
          icon: 'bi-send-check',
          color: '#1976d2',
          bgColor: '#e3f2fd',
          title: 'Order Dispatched',
          message: 'Your order has been dispatched and is on its way! Track the delivery status.',
        };
      case 'delivered':
        return {
          icon: 'bi-check-circle-fill',
          color: '#2e7d32',
          bgColor: '#e8f5e9',
          title: 'Order Delivered',
          message: 'Your order has been delivered successfully! We hope you are satisfied.',
        };
      case 'cancel':
        return {
          icon: 'bi-x-circle',
          color: '#f44336',
          bgColor: '#ffebee',
          title: 'Order Cancelled',
          message: 'Your order has been cancelled. If you have questions, please contact support.',
        };
      default:
        return {
          icon: 'bi-info-circle',
          color: '#9e9e9e',
          bgColor: '#f5f5f5',
          title: 'Status Update',
          message: `Your order is currently in '${status}' status. We will keep you updated.`,
        };
    }
  };

  const fecthData = useCallback(async () => {
    setLoading(true);
    try {
      const response = await axios.get(
        `${config.apiUrl}/customer/order-detail/${params.id}`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: config.token,
            Accept: "application/json",
          },
        }
      );

      setData((prevData) => ({
        ...prevData,
        productData: {
          unique_id: response.data.data.unique_id,
          order_id: response.data.data.order_id,
          category: response.data.data.commodity_product.category.name,
          product: response.data.data.commodity_product.name,
          brand: response.data.data.brand.name,
          order_date: response.data.data.updated_at,
          purpose: response.data.data.purpose,
          message: response.data.data.description,
        },
        billing: response.data.data.billing_address,
        consignee: response.data.data.consignee_detail,
        variation: response.data.data.variation,
        status: response.data.data.status,
        orderData: {
          base_price: response.data.data.base_price,
          freight: response.data.data.transport_price,
          total_quantity: response.data.data.total_quantity,
          total_ex_price: response.data.data.ex_price,
          total_freight:
            +response.data.data.total_quantity *
            +response.data.data.transport_price,
          total_payable_amount: response.data.data.for_price,
          order_amount: response.data.data.token_amount,
          paid_amount: response.data.data.paid_amount,
          due_amount: response.data.data.due_amount,
        },
        quality: {
          certificate: response.data.data.quality_check_certificate,
          images: response.data.data.quality_check_image,
          visibility: response.data.data.quality_check_visibility,
        },
        update_for: response.data.data.update_for,
        driver: response.data.data.driver_list,
        invoice_list: response.data.data.invoice_list,
        credit_days: response.data.data.credit_days,
        packaging_charge: response.data.data.selected_packaging_charge,
        selected_quality: response.data.data.selected_quality,
        load_within: response.data.data.load_within,
        total_invoice_amount: parseInt(response.data.data.total_invoice_amount) || 0,
      }));
    } catch (error) {
      if (
        error.response &&
        (error.response.status === 404 ||
          error.response.status === 400 ||
          error.response.status === 500)
      ) {
        setExist(false);
      }
      if (error.response && error.response.status === 401) {
        logout();
      }
    } finally {
      setLoading(false);
    }
  }, [params.id, logout]);

  useEffect(() => {
    fecthData();
  }, [fecthData]);

  return (
    <>
      <div className="page-content">
        <div className="container-fluid">
          <div className="row-layout mrb1">
            {loading ? (
              <div className="d-flex justify-content-center">
                <Dataloader />
              </div>
            ) : (
              <>
                {exist ? (
                  <>
                    <div className="row-hd-txt">
                      <div className="row-hd-txt-left">
                        <img src={icon} alt="icon" />
                        <h5>Order Details</h5>
                      </div>
                      {/* <div className="status-right">
                        <h6 
                          className="status sent" 
                          style={{ 
                            backgroundColor: getStatusConfig(data.status).bgColor,
                            color: getStatusConfig(data.status).color,
                            padding: '8px 16px',
                            borderRadius: '6px',
                            display: 'inline-flex',
                            alignItems: 'center',
                            gap: '8px'
                          }}
                        >
                          <i className={getStatusConfig(data.status).icon}></i>
                          {getStatusConfig(data.status).title}
                        </h6>
                      </div> */}
                    </div>
                    {/* Status Message Alert */}
                    <div 
                      className="alert mb-3" 
                      style={{ 
                        backgroundColor: getStatusConfig(data.status).bgColor,
                        borderLeft: `4px solid ${getStatusConfig(data.status).color}`,
                        color: '#333'
                      }}
                    >
                      <i 
                        className={`${getStatusConfig(data.status).icon} me-2`}
                        style={{ color: getStatusConfig(data.status).color, fontSize: '1.2rem' }}
                      ></i>
                      <strong>{getStatusConfig(data.status).title}:</strong> {getStatusConfig(data.status).message}
                    </div>
                    <div className="row g-3 purchase-order-row">
                      <div className="col-lg-4 px-2">
                        <div className="purchase-order-table">
                          <label className="order-label">Product Details</label>
                          <table className="table chart-table table-bordered m-0">
                            <tbody>
                              <tr>
                                <td>Quotation No:</td>
                                <td>{data.productData.unique_id}</td>
                              </tr>
                              <tr>
                                <td>Order Id:</td>
                                <td>{data.productData.order_id}</td>
                              </tr>
                              <tr>
                                <td>Category:</td>
                                <td>{data.productData.category}</td>
                              </tr>
                              <tr>
                                <td>Brand:</td>
                                <td>{data.productData.brand}</td>
                              </tr>
                              <tr>
                                <td>Product:</td>
                                <td>{data.productData.product}</td>
                              </tr>
                              <tr>
                                <td>Order Date:</td>
                                <td>{data.productData.order_date}</td>
                              </tr>
                              {data.selected_quality && (
                                <tr>
                                  <td>Quality:</td>
                                  <td>{data.selected_quality.name}</td>
                                </tr>
                              )}
                              {data.packaging_charge && (
                                <tr>
                                  <td>Packaging:</td>
                                  <td>
                                    {data.packaging_charge.name}
                                  </td>
                                </tr>
                              )}
                              <tr>
                                <td>Purpose:</td>
                                <td>{data.productData.purpose ?? "---"}</td>
                              </tr>
                              <tr>
                                <td>Message:</td>
                                <td>{data.productData.message ?? "---"}</td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </div>
                      <div className="col-lg-8 px-2">
                        <div className="purchase-order-table card-shadow bg-primary-gradient">
                          <div className="pb-1 mb-1">
                            <p className="order-label mb-0 fs-4">
                              Order Details
                            </p>
                            {data.status !== "pending" && (
                              <label className="label-booked fs-3">
                                <img src={booked} alt="Success Icon" width="120" height="80" />
                              </label>
                            )}
                          </div>
                          <table>
                            <tbody>
                              <tr>
                                <td>Basic Price:</td>
                                <td className="text-success animate-price fs-4">
                                  Rs{" "}
                                  <NumberFormatter
                                    number={data.orderData.base_price}
                                  />
                                </td>
                              </tr>
                              <tr>
                                <td>Total Quantity:</td>
                                <td>{data.orderData.total_quantity}MT</td>
                              </tr>
                              <tr>
                                <td>Dispatch Within:</td>
                                <td>{data.load_within ? data.load_within + " Days" : "0 Days"}</td>
                              </tr>
                              <tr>
                                <td>Credit Days:</td>
                                <td>
                                  {data.credit_days ? data.credit_days + " Days" : "0 Days"}
                                </td>
                              </tr>
                            </tbody>
                          </table>
                          <p className="price-note border-bottom text-bill pb-1 mb-1">
                            {" "}
                            Dispatch Within agreed days, else seller may cancel or dispatch at their choice.
                          </p>
                          {(data.orderData.freight > 0 || data.orderData.total_freight > 0) && (
                            <>
                              <table>
                                <tbody>
                                  <tr>
                                    <td>Freight:</td>
                                    <td>
                                      Rs{" "}
                                      <NumberFormatter
                                        number={data.orderData.freight}
                                      />
                                      /MT
                                    </td>
                                  </tr>
                                  {/* <tr>
                                    <td>
                                      Total Freight
                                      <small>(Freight * Total Quantity)</small>:
                                    </td>
                                    <td>
                                      Rs{" "}
                                      <NumberFormatter
                                        number={data.orderData.total_freight}
                                      />{" "}
                                    </td>
                                  </tr> */}
                                </tbody>
                              </table>
                              <p className="price-note border-bottom text-bill pb-1 mb-1">
                                {" "}
                                Freight may change +/- 100. (Freight depends on
                                demand &amp; supply of trucks on loading day)
                              </p>
                            </>
                          )}
                          <table>
                            <tbody>
                              <tr>
                                <td>
                                  Total Amount Payable
                                  {data.orderData.freight > 0 || data.orderData.total_freight > 0 ? (
                                    <small> (Ex-Factory + Freight)</small>
                                  ): (
                                    <small> (Ex-Factory)</small>
                                  )}:
                                </td>
                                <td>
                                  {data.total_invoice_amount > 0 ? (
                                    <>
                                      Rs{" "}
                                      <NumberFormatter
                                        number={data.total_invoice_amount}
                                      />
                                    </>
                                  ) : (
                                    <>
                                      Rs{" "}
                                      <NumberFormatter
                                        number={data.orderData.total_payable_amount}
                                      />
                                    </>
                                  )}
                                </td>
                              </tr>
                            </tbody>
                          </table>
                          <p className="price-note text-bill">
                            {" "}
                            Disclaimer: The invoice amount will be updated after
                            the goods are loaded and the final quantity is
                            confirmed.
                          </p>
                        </div>
                      </div>
                      <div className="col-lg-6 px-2">
                        <div className="purchase-order-table">
                          <label className="order-label">Estimate Price</label>
                          <div className="table-responsive">
                            <table className="table chart-table table-bordered m-0">
                              <thead>
                                <tr>
                                  <th scope="col">Requirements</th>
                                  <th scope="col">Ex Price</th>
                                  <th scope="col">Ex Price x Qty</th>
                                </tr>
                              </thead>
                              <tbody>
                                {data.variation.map((item) => (
                                  <tr key={item.id}>
                                    <td className="fw-normal">
                                      {item.value[0].value}
                                      {item.value[0].unit.short_name} - {item.quantity}MT
                                    </td>
                                    <td>
                                      Rs{" "}
                                      <NumberFormatter number={item.per_unit_price} />
                                      /MT
                                    </td>
                                    <td>
                                      Rs{" "}
                                      <NumberFormatter number={item.final_price} />
                                    </td>
                                  </tr>
                                ))}
                                <tr>
                                  <td colSpan="2" className="text-start fw-bold">
                                    Total Ex Price:
                                  </td>
                                  <td className="fw-bold">
                                    Rs{" "}
                                    <NumberFormatter number={data.orderData.total_ex_price} />
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                            {data.update_for === "quantity" && (
                              <p className="pb-1 mb-1 text-danger">
                                <b>🚨 Note:</b> Quantity has been updated.
                              </p>
                            )}
                            {data.update_for === "variant" && (
                              <p className="pb-1 mb-1 text-danger">
                                <b>🚨 Note:</b> Size has been updated.
                              </p>
                            )}
                            {data.update_for === "both" && (
                              <p className="pb-1 mb-1 text-danger">
                                <b>🚨 Note:</b> Size & Quantity has been updated.
                              </p>
                            )}
                          </div>
                          <p className="price-note">Rate included - loading charges, insurance charges, packaging charges, quality inspection charges & GST.</p>
                          <p className="price-note"> Note - Final invoice will be based on final loaded quantity at booked rates.</p>
                        </div>
                      </div>
                      <div className="col-lg-6 px-2">
                        <div className="purchase-order-table">
                          <label className="order-label">Order Payment</label>
                          <table className="table chart-table table-bordered m-0">
                            <tbody>
                              <tr>
                                <td>Receivable Amount:</td>
                                <td>
                                  {data.total_invoice_amount > 0 ? (
                                    <>
                                      Rs{" "}
                                      <NumberFormatter
                                        number={data.total_invoice_amount}
                                      />
                                      {/* <NumberFormatter
                                        number={data.orderData.total_payable_amount}
                                      /> */}
                                    </>
                                  ) : (
                                    <span className="text-muted">Final invoice to be decided</span>
                                  )}
                                </td>
                              </tr>
                              {/* <tr>
                                <td>Booking Amount:</td>
                                <td>
                                  Rs{" "}
                                  <NumberFormatter
                                    number={data.orderData.order_amount}
                                  />
                                </td>
                              </tr> */}
                              <tr>
                                <td>Booking Amount:</td>
                                <td>
                                  Rs{" "}
                                  <NumberFormatter
                                    number={data.orderData.paid_amount}
                                  />
                                </td>
                              </tr>
                              {/* <tr>
                                <td>Due Amount:</td>
                                <td>
                                  Rs{" "}
                                  <NumberFormatter
                                    number={data.orderData.due_amount}
                                  />
                                </td>
                              </tr> */}
                            </tbody>
                          </table>
                          {(data.status === "pending" ||
                            data.status === "confirm" ||
                            data.status === "vehicle booked" ||
                            data.status === "loading") && (
                              <p className="price-note">
                                {" "}
                                Note - Once Final invoice is generated, you have
                                to pay final amount to complete your order.
                              </p>
                            )}
                          <div className="text-center mt-1">
                            <Link
                              type="button"
                              className="btn w-50"
                              title="Order Invoice"
                              to={`/order-ledger/${params.id}`}
                            >
                              <i className="bi bi-eye me-1"></i>View Ledger
                            </Link>
                          </div>
                        </div>
                      </div>
                      <div className="col-lg-6 col-md-6 px-2">
                        <div className="purchase-order-table">
                          <label className="order-label">Buyer(Bill To)</label>
                          <table className="table chart-table table-bordered m-0">
                            <tbody>
                              <tr>
                                <td>Company Name:</td>
                                <td>{data.billing.company_name}</td>
                              </tr>
                              <tr>
                                <td>Phone Number:</td>
                                <td>{data.billing.phone}</td>
                              </tr>
                              <tr>
                                <td>GST:</td>
                                <td>{data.billing.gst}</td>
                              </tr>
                              <tr>
                                <td>Address Line1:</td>
                                <td>{data.billing.address_line_one}</td>
                              </tr>
                              <tr>
                                <td>Address Line2:</td>
                                <td>{data.billing.address_line_two}</td>
                              </tr>
                              <tr>
                                <td>City:</td>
                                <td>{data.billing.city}</td>
                              </tr>
                              <tr>
                                <td>State:</td>
                                <td>{data.billing.state}</td>
                              </tr>
                              <tr>
                                <td>Pincode:</td>
                                <td>{data.billing.pincode ?? data.billing.pin_code}</td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </div>
                      <div className="col-lg-6 col-md-6 px-2">
                        <div className="purchase-order-table">
                          <label className="order-label">
                            Consignee(Ship To)
                          </label>
                          <table className="table chart-table table-bordered table-responsive m-0">
                            <tbody>
                              <tr>
                                <td>Company Name:</td>
                                <td>{data.consignee.company_name}</td>
                              </tr>
                              <tr>
                                <td>Phone Number:</td>
                                <td>{data.consignee.phone}</td>
                              </tr>
                              <tr>
                                <td>GST:</td>
                                <td>{data.consignee.gst}</td>
                              </tr>
                              <tr>
                                <td>Address Line1:</td>
                                <td>{data.consignee.address_line_one}</td>
                              </tr>
                              <tr>
                                <td>Address Line2:</td>
                                <td>{data.consignee.address_line_two}</td>
                              </tr>
                              <tr>
                                <td>City:</td>
                                <td>{data.consignee.city}</td>
                              </tr>
                              <tr>
                                <td>State:</td>
                                <td>{data.consignee.state}</td>
                              </tr>
                              <tr>
                                <td>Pincode:</td>
                                <td>{data.consignee.pincode ?? data.consignee.pin_code}</td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </div>
                      {data.quality.visibility && (
                        <div className="col-lg-6 px-2">
                          <div className="purchase-order-table">
                            <label className="order-label">
                              Quality Check Report
                            </label>
                            <div className="row px-2 g-3">
                              {data.quality.images.length > 0 ? (
                                data.quality.images.map((quality, index) => {
                                  return (
                                    <div
                                      className="col-lg-4 col-6 px-2"
                                      key={index}
                                    >
                                      <Link
                                        to={quality.image}
                                        target="_blank"
                                        className="d-flex justify-content-center border rounded-2"
                                      >
                                        <img
                                          src={quality.image}
                                          alt="Quality Check"
                                          width={140}
                                          title="Click to view"
                                        />
                                      </Link>
                                    </div>
                                  );
                                })
                              ) : (
                                <div className="col-lg-6">
                                  <p className="text-danger m-0 fw-bold">
                                    Not Available
                                  </p>
                                </div>
                              )}
                              {data.quality.certificate && (
                                <div className="col-lg-4 col-6 px-2">
                                  <Link
                                    to={data.quality.certificate}
                                    target="_blank"
                                    className="d-flex justify-content-center border rounded-2"
                                  >
                                    <img
                                      src={data.quality.certificate}
                                      width={140}
                                      alt="Quality Certificate"
                                      title="Quality Certificate"
                                    />
                                  </Link>
                                </div>
                              )}
                            </div>
                          </div>
                        </div>
                      )}
                      {data.driver.length > 0 && (
                        <div className="col-lg-12 px-2">
                          <div className="purchase-order-table">
                            <label className="order-label">
                              Transporters List
                            </label>
                            <div className="row px-2 g-3 transport_row">
                              {data.driver.map((driver, index) => {
                                return (
                                  <div className="col-lg-6 px-2" key={index}>
                                    <div className="transport border rounded-2">
                                      <div className="row g-3">
                                        <div className="col-lg-6 px-2">
                                          <label className="fw-bold">
                                            Driver Details:
                                          </label>
                                          <table className="table table-bordered m-0">
                                            <tbody>
                                              <tr>
                                                <td>
                                                  <img
                                                    src={driver.photo}
                                                    className="img-fluid"
                                                    title="Driver"
                                                    alt="Driver"
                                                  />
                                                </td>
                                                <td>
                                                  <img
                                                    src={
                                                      driver.driver_with_vehicle_photo
                                                    }
                                                    className="img-fluid"
                                                    title="Driver With Vehicle"
                                                    alt="Driver Vehicle"
                                                  />
                                                </td>
                                              </tr>
                                            </tbody>
                                          </table>
                                          <table className="table table-bordered m-0">
                                            <tbody>
                                              <tr>
                                                <td>Name:</td>
                                                <td>{driver.name}</td>
                                              </tr>
                                              <tr>
                                                <td>Phone Number:</td>
                                                <td>{driver.phone}</td>
                                              </tr>
                                              <tr>
                                                <td>Alternate Number:</td>
                                                <td>
                                                  {
                                                    driver.alternate_phone_number
                                                  }
                                                </td>
                                              </tr>
                                              <tr>
                                                <td>Vehical Number:</td>
                                                <td>{driver.vehicle_number}</td>
                                              </tr>
                                              <tr>
                                                <td>Total Quantity:</td>
                                                <td>{driver.final_quantity_by_seller}</td>
                                              </tr>
                                              <tr>
                                                <td>E-Way Bill Expiry Date:</td>
                                                <td>{driver.ebill_expiry_date}</td>
                                              </tr>
                                            </tbody>
                                          </table>
                                        </div>
                                        <div className="col-lg-6 px-2">
                                          <label className="fw-bold">
                                            Transporter Details:
                                          </label>
                                          <table className="table table-bordered m-0">
                                            <tbody>
                                              <tr>
                                                <td>
                                                  <img
                                                    src={
                                                      driver.loaded_vehicle_photo
                                                    }
                                                    className="img-fluid"
                                                    title="Loaded Vehicle Photo"
                                                    alt="Loaded Vehicle"
                                                  />
                                                </td>
                                                <td>
                                                  <img
                                                    src={
                                                      driver.unloaded_vehicle_photo
                                                    }
                                                    className="img-fluid"
                                                    title="Unloaded Vehicle Photo"
                                                    alt="Unloaded Vehicle"
                                                  />
                                                </td>
                                              </tr>
                                            </tbody>
                                          </table>
                                          <table className="table table-bordered m-0">
                                            <tbody>
                                              <tr>
                                                <td>Name:</td>
                                                <td>
                                                  {driver.transporter_name}
                                                </td>
                                              </tr>
                                              <tr>
                                                <td>Phone Number:</td>
                                                <td>
                                                  {
                                                    driver.transporter_phone_number
                                                  }
                                                </td>
                                              </tr>
                                              <tr>
                                                <td>Alternate Number:</td>
                                                <td>---</td>
                                              </tr>
                                              <tr>
                                                <td>Tracking Number:</td>
                                                <td>
                                                  {" "}
                                                  {driver.tracking_number}
                                                </td>
                                              </tr>
                                            </tbody>
                                          </table>
                                        </div>
                                        <div className="col-lg-12 px-2">
                                          <div className="row">
                                            <div className="col-4 pe-0">
                                              <Link
                                                to={driver.ebill}
                                                type="button"
                                                className="btn"
                                                title="E Bill"
                                                target="_blank"
                                              >
                                                <i className="bi bi-journal-text"></i>
                                                E-Way Bill
                                              </Link>
                                            </div>
                                            <div className="col-4 pe-0">
                                              <Link
                                                to={driver.transport_receipt}
                                                type="button"
                                                className="btn"
                                                title="Transport Bill"
                                                target="_blank"
                                              >
                                                <i className="bi bi-truck"></i>{" "}
                                                Tnsp Bill
                                              </Link>
                                            </div>
                                            <div className="col-4">
                                              <Link
                                                to={driver.invoice}
                                                type="button"
                                                className="btn"
                                                title="Invoice"
                                                target="_blank"
                                              >
                                                <i className="bi bi-receipt"></i>
                                                Invoice
                                              </Link>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                );
                              })}
                            </div>
                          </div>
                        </div>
                      )}

                      {data.invoice_list.length > 0 && (
                        <div className="col-lg-12 px-2">
                          <div className="purchase-order-table">
                            <label className="order-label">Invoice List</label>
                            <div className="row px-2 g-3 transport_row">
                              {data.invoice_list.map((invoice, index) => {
                                return (
                                  <div className="col-lg-6 px-2" key={index}>
                                    <div className="transport border rounded-2">
                                      <div className="row g-3">
                                        <div className="col-lg-12 px-2">
                                          <table className="table table-bordered m-0">
                                            <tbody>
                                              {invoice.name && (
                                                <tr>
                                                  <td>Invoice Name:</td>
                                                  <td>{invoice.name}</td>
                                                </tr>
                                              )}
                                              {invoice.vehicle_number && (
                                                <tr>
                                                  <td>Vehicle Number:</td>
                                                  <td>{invoice.vehicle_number}</td>
                                                </tr>
                                              )}
                                              {invoice.amount > 0 && (
                                                <tr>
                                                  <td>Amount:</td>
                                                  <td>
                                                    Rs{" "}
                                                    <NumberFormatter
                                                      number={invoice.amount}
                                                    />
                                                  </td>
                                                </tr>
                                              )}
                                              {invoice.ebill_expiry_date && (
                                                <tr>
                                                  <td>E-Way Bill Expiry:</td>
                                                  <td>
                                                    {invoice.ebill_expiry_date}
                                                    {' | '}
                                                    {invoice.is_expired_today ? (
                                                      <span className="text-danger fw-bold">
                                                        Expired Today
                                                      </span>
                                                    ) : invoice.days_left <= 0 ? (
                                                      <span className="text-danger fw-bold">
                                                        Expired
                                                      </span>
                                                    ) : invoice.days_left <= 3 ? (
                                                      <span className="text-warning">
                                                        {invoice.days_left} Days
                                                        Left
                                                      </span>
                                                    ) : (
                                                      <span className="text-success">
                                                        {invoice.days_left} Days
                                                        Left
                                                      </span>
                                                    )}
                                                  </td>
                                                </tr>
                                              )}
                                              {invoice.debit_note_amount && (
                                                <tr>
                                                  <td>Debit Note Amount:</td>
                                                  <td>
                                                    Rs{" "}
                                                    <NumberFormatter
                                                      number={invoice.debit_note_amount}
                                                    />
                                                  </td>
                                                </tr>
                                              )}
                                              {invoice.credit_note_amount && (
                                                <tr>
                                                  <td>Credit Note Amount:</td>
                                                  <td>
                                                    Rs{" "}
                                                    <NumberFormatter
                                                      number={invoice.credit_note_amount}
                                                    />
                                                  </td>
                                                </tr>
                                              )}
                                            </tbody>
                                          </table>
                                        </div>
                                        <div className="col-lg-12 px-2">
                                          <div className="row">
                                            {invoice.invoice && (
                                              <div className="col-4 pe-0">
                                                <Link
                                                  to={invoice.invoice}
                                                  type="button"
                                                  className="btn"
                                                  title="Invoice"
                                                  target="_blank"
                                                >
                                                  <i className="bi bi-receipt"></i>{" "}
                                                  Invoice
                                                </Link>
                                              </div>
                                            )}
                                            {invoice.ebill && (
                                              <div className="col-4 pe-0">
                                                <Link
                                                  to={invoice.ebill}
                                                  type="button"
                                                  className="btn"
                                                  title="E-Waybill"
                                                  target="_blank"
                                                >
                                                  <i className="bi bi-journal-text"></i>{" "}
                                                  E-Way Bill
                                                </Link>
                                              </div>
                                            )}
                                            {invoice.transport_receipt && (
                                              <div className="col-4">
                                                <Link
                                                  to={invoice.transport_receipt}
                                                  type="button"
                                                  className="btn"
                                                  title="Transport Receipt"
                                                  target="_blank"
                                                >
                                                  <i className="bi bi-truck"></i>{" "}
                                                  Receipt
                                                </Link>
                                              </div>
                                            )}

                                            {invoice.debit_note && (
                                              <div className="col-6 pe-0 mt-1">
                                                <Link
                                                  to={invoice.debit_note}
                                                  type="button"
                                                  className="btn"
                                                  title="Debit Note"
                                                  target="_blank"
                                                >
                                                  <i className="bi bi-file-earmark-minus"></i>{" "}
                                                  Debit
                                                </Link>
                                              </div>
                                            )}

                                            {invoice.credit_note && (
                                              <div className="col-6 mt-1">
                                                <Link
                                                  to={invoice.credit_note}
                                                  type="button"
                                                  className="btn"
                                                  title="Credit Note"
                                                  target="_blank"
                                                >
                                                  <i className="bi bi-file-earmark-plus"></i>{" "}
                                                  Credit
                                                </Link>
                                              </div>
                                            )}
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                );
                              })}
                            </div>
                          </div>
                        </div>
                      )}

                    </div>
                  </>
                ) : (
                  <NoData />
                )}
              </>
            )}
          </div>
        </div>
      </div>
    </>
  );
}
